import { render, staticRenderFns } from "./ContentLoader.vue?vue&type=template&id=099c1428&"
import script from "./ContentLoader.vue?vue&type=script&lang=js&"
export * from "./ContentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports